import { CookieService } from './cookie.service';
export function cookieServiceFactory(cookieOptionsProvider) {
    return new CookieService(cookieOptionsProvider);
}



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3975732384/src/~/ngx-cookie/src/cookie.factory.js
// module id = k47s
// module chunks = 3